var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalytic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 490 490",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "line_35_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.203,490V281.061H67.015V490H174.203z M97.64,311.686h45.938v147.689H97.64V311.686z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.828,490h107.188V210.623H204.828V490z M235.453,241.248h45.937v218.127h-45.937V241.248z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.828,136.312H342.64V490h107.188V136.312z M419.203,459.375h-45.938V166.937h45.938V459.375z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.799,0l-89.716,49.046l29.982,19.432C190.572,185.894,41.704,214.344,40.172,214.635l5.451,30.135 c6.845-1.24,163.783-30.962,265.304-159.526l30.855,19.983L344.799,0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytic);
export default __webpack_public_path__ + "static/media/analytic.dfe7ed611551b91d927043ff24c8b44d.svg";
export { ForwardRef as ReactComponent };